import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useGeneralStyles = makeStyles((theme: Theme) =>
  createStyles({
    numberedHeadings: {
      '& .pdfTitle': { counterReset: 'section subSection subSection2' },
    },
    bold: {
      fontWeight: 'bold',
    },
    italic: {
      fontStyle: 'italic',
    },
    medium: {
      fontWeight: 500,
    },
    regularText: {
      fontSize: '11pt',
      color: theme.palette.common.black,
    },
    mediumText: {
      fontSize: '12pt',
      fontWeight: 500,
      color: theme.palette.common.black,
    },
    largeText: {
      fontSize: '14pt',
      fontWeight: 500,
      color: theme.palette.common.black,
    },
    strongText: {
      fontWeight: 'bold',
      fontSize: '12pt',
      color: theme.palette.common.black,
    },
    bigText: {
      fontWeight: 900,
      fontSize: '16pt',
      color: theme.palette.common.black,
    },
    value: {
      color: theme.palette.common.black,
    },
    gray: {
      color: theme.palette.grey['600'],
    },
    supplement: {
      fontSize: '9pt',
      color: theme.palette.grey['600'],
    },
    smallText: {
      fontSize: '8pt',
    },
    left: {
      textAlign: 'left',
    },
    center: {
      textAlign: 'center',
    },
    right: {
      textAlign: 'right',
    },
    list: {
      marginBottom: theme.spacing(3),
      '& li': {
        marginBottom: theme.spacing(1),
      },
    },
    listA: {
      listStyleType: 'lower-roman'
    },
    bigLine: {
      padding: theme.spacing(1, 0.5),
      margin: theme.spacing(0.5),
    },
    lines: {
      '& .MuiGrid-item': {
        padding: theme.spacing(0, 0.5),
        marginBottom: theme.spacing(0.5),
      },
    },
    twoColumns: {
      display: 'grid',
      gridColumnGap: theme.spacing(7),
      gridTemplateColumns: '1fr 1fr',
      alignItems: 'start',
      '& > p:first-child, & > div > p:first-child, & > h2:first-child, & > div > h2:first-child': {
        marginTop: 0,
      },
      '& > p:last-child, & > div > p:last-child': {
        marginBottom: 0,
      },
      '&.third': {
        gridTemplateColumns: '1fr 2fr',
        gridColumnGap: theme.spacing(3),
      },
    },
    threeColumns: {
      display: 'grid',
      gridColumnGap: theme.spacing(3),
      gridTemplateColumns: '1fr 1fr 1fr',
      alignItems: 'start',
      '& > p:first-child, & > div > p:first-child, & > h2:first-child, & > div > h2:first-child': {
        marginTop: 0,
      },
      '& > p:last-child, & > div > p:last-child': {
        marginBottom: 0,
      },
    },
    threeColumnsTight: {
      gridColumnGap: theme.spacing(0.5),
    },
    bankAccounts: {
      marginRight: theme.spacing(7),
    },
    box: {
      padding: theme.spacing(0.5),
      margin: theme.spacing(3, 0, 3, 0),
      '&.tight': { margin: theme.spacing(1, 0, 1, 0), }
    },
    noMargin: {
      margin: 0,
    },
    avoidPageBreak: {
      pageBreakInside: 'avoid',
    },
    halfXs: {
      maxWidth: '4.15%',
      flexBasis: '4.15%',

    }
  }),
);

export default useGeneralStyles;
